/**
 * @generated SignedSource<<13d8e9cdbc6d58d9f16f7cc11c7b3fc3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type readView_nativeIssueTable_LinkRelationshipTypeReadView$data = {
  readonly issueLink: {
    readonly relationName: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "readView_nativeIssueTable_LinkRelationshipTypeReadView";
};
export type readView_nativeIssueTable_LinkRelationshipTypeReadView$key = {
  readonly " $data"?: readView_nativeIssueTable_LinkRelationshipTypeReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"readView_nativeIssueTable_LinkRelationshipTypeReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "readView_nativeIssueTable_LinkRelationshipTypeReadView",
  "selections": [
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relationName"
        }
      ]
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "1680e7e86951f44797d1909f0f0ed3ba";

export default node;
